import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { UIText1, UIText2 } from '../../typography';
import { IconFunctionalWarningCircle16, IconFunctionalWarningCircle24, IconFunctionalInformationCircle16, IconFunctionalInformationCircle24, IconFunctionalSuccessCircle16, IconFunctionalSuccessCircle24 } from '@cian/ui-kit-design-tokens/icons';
import { Spinner } from '../../loader';
import { CloseButton } from '../../internal/components/CloseButton';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Status = function Status(_ref) {
  var _ref$status = _ref.status,
    status = _ref$status === void 0 ? 'info' : _ref$status,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'M' : _ref$size;
  var sizePx = size === 'S' ? '16' : '24';
  var statusIcons = {
    info16: /*#__PURE__*/_jsx(IconFunctionalInformationCircle16, {
      color: "icon-main-default"
    }),
    info24: /*#__PURE__*/_jsx(IconFunctionalInformationCircle24, {
      color: "icon-main-default"
    }),
    error16: /*#__PURE__*/_jsx(IconFunctionalWarningCircle16, {
      color: "icon-negative-default"
    }),
    error24: /*#__PURE__*/_jsx(IconFunctionalWarningCircle24, {
      color: "icon-negative-default"
    }),
    success16: /*#__PURE__*/_jsx(IconFunctionalSuccessCircle16, {
      color: "icon-positive-default"
    }),
    success24: /*#__PURE__*/_jsx(IconFunctionalSuccessCircle24, {
      color: "icon-positive-default"
    }),
    spinner16: /*#__PURE__*/_jsx(Spinner, {
      color: "icon-secondary-default",
      size: 16
    }),
    spinner24: /*#__PURE__*/_jsx(Spinner, {
      color: "icon-secondary-default",
      size: 24
    })
  };
  return statusIcons["".concat(status).concat(sizePx)];
};

/**
 * @deprecated Используйте компонент Toast
 */
export var Snackbar = /*#__PURE__*/React.forwardRef(function Snackbar(props, ref) {
  var action = props.action,
    _props$anchorOrigin = props.anchorOrigin,
    _props$anchorOrigin2 = _props$anchorOrigin === void 0 ? {
      vertical: 'top',
      horizontal: 'center'
    } : _props$anchorOrigin,
    vertical = _props$anchorOrigin2.vertical,
    horizontal = _props$anchorOrigin2.horizontal,
    _props$autoHideDurati = props.autoHideDuration,
    autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
    message = props.message,
    secondaryMessage = props.secondaryMessage,
    hideCloseButton = props.hideCloseButton,
    onClose = props.onClose,
    open = props.open,
    _props$size = props.size,
    size = _props$size === void 0 ? 'M' : _props$size,
    status = props.status;
  var timerAutoHide = React.useRef();
  var _React$useState = React.useState(open),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    shouldRender = _React$useState2[0],
    setShouldRender = _React$useState2[1];
  React.useEffect(function () {
    if (open) {
      setShouldRender(true);
    }
  }, [open]);
  var setAutoHideTimer = React.useCallback(function (autoHideDurationParam) {
    if (!onClose || autoHideDurationParam == null) {
      return;
    }
    clearTimeout(timerAutoHide.current);
    timerAutoHide.current = setTimeout(function () {
      onClose();
    }, autoHideDurationParam);
  }, [onClose]);
  React.useEffect(function () {
    if (open) {
      setAutoHideTimer(autoHideDuration);
    }
    return function () {
      clearTimeout(timerAutoHide.current);
    };
  }, [open, autoHideDuration, setAutoHideTimer]);
  var containerClasses = clsx(styles['container'], styles[vertical], styles[horizontal], styles[size], open ? styles['show'] : styles['hide']);
  var TextComponent = size === 'S' ? UIText2 : UIText1;
  if (!shouldRender) {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: containerClasses,
    ref: ref,
    onAnimationEnd: function onAnimationEnd() {
      if (!open) {
        setShouldRender(false);
      }
    },
    children: [/*#__PURE__*/_jsxs("section", {
      className: styles.rightSection,
      children: [status && /*#__PURE__*/_jsx(Status, {
        size: size,
        status: status
      }), message && /*#__PURE__*/_jsx(TextComponent, {
        color: "text-inverted-default",
        children: message
      })]
    }), /*#__PURE__*/_jsx("section", {
      className: styles.middleSection,
      children: secondaryMessage && /*#__PURE__*/_jsx("section", {
        className: styles.secondaryMessage,
        children: /*#__PURE__*/_jsx(TextComponent, {
          color: "current_color",
          children: secondaryMessage
        })
      })
    }), /*#__PURE__*/_jsxs("section", {
      className: styles.leftSection,
      children: [action && /*#__PURE__*/_jsx("div", {
        role: "button",
        onClick: action.onClick,
        className: styles.actionButton,
        children: /*#__PURE__*/_jsx(TextComponent, {
          color: "current_color",
          children: action.title
        })
      }), !hideCloseButton && !action && /*#__PURE__*/_jsx("div", {
        role: "button",
        className: styles.closeButton,
        children: /*#__PURE__*/_jsx(CloseButton, {
          className: styles['close'],
          onClick: onClose ? onClose : function () {},
          size: 12,
          theme: "dark"
        })
      })]
    })]
  });
});